export default __webpack_public_path__ + "static/media/keyboardArrowRight.e5dfb00f.svg";